import { render, staticRenderFns } from "./AppBlock.vue?vue&type=template&id=8616083a&lang=pug&"
import script from "./AppBlock.vue?vue&type=script&lang=js&"
export * from "./AppBlock.vue?vue&type=script&lang=js&"
import style0 from "./AppBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports